import domReady from '@roots/sage/client/dom-ready';

/**
 * Application entrypoint
 */
domReady(async () => {
  jQuery(function ($) {
    $(document).on('click', '.quantity .plus', function () {
      var input = $(this).closest('.quantity').find('input.qty');
      $(input).val(parseInt($(input).val()) + 1);
      $(input).trigger('change');
    });

    $(document).on('click', '.quantity .minus', function () {
      var input = $(this).closest('.quantity').find('input.qty');
      var val = Math.max(0, parseInt($(input).val()) - 1);
      $(input).val(val);
      $(input).trigger('change');
    });

    $(document).on('click', '.bac-dropdown', function () {
      $('.bac-table').animate({
        height: 'toggle',
        'padding-top': 'toggle',
        'padding-bottom': 'toggle',
      });
    });

    $(document).on('click', '.bac-popup-close', function () {
      $('.bac-popup').removeClass('bac-popup-opened');
    });

    var currentPath = window.location.pathname;
    var cookieName = 'bac-popup-opened' + currentPath;

    if (!document.cookie.includes(cookieName)) {
      $('.bac-popup').delay(500).addClass('bac-popup-opened');
      document.cookie = `${cookieName}=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/`;
    }

    $(document).on('change', '#justificatif', function () {
      if (this.files.length === 0) {
        $('.justificatif-name').empty();
      } else {
        var file = this.files[0];
        $('.justificatif-name').text(`Fichier sélectionné : ${file.name}`);
        $('.form-checkout-main').addClass('loading');

        var formData = new FormData();
        formData.append('justificatif_file', file);

        $.ajax({
          url: wc_checkout_params.ajax_url + '?action=justificatif',
          type: 'POST',
          data: formData,
          contentType: false,
          enctype: 'multipart/form-data',
          processData: false,
          success: function (response) {
            $('input[name="justificatif_field"]').val(response);
          },
          complete: function () {
            $('.form-checkout-main').removeClass('loading');
          },
        });
      }
    });

    let timeout;
    $('.woocommerce-page').on('change', 'input.qty', function () {
      if (timeout !== undefined) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(function () {
        $("[name='update_cart']").trigger('click'); // trigger cart update
      }, 500); // 1 second delay, half a second (500) seems comfortable too
    });

    $(document).on(
      'change',
      'form.checkout input[name^="shipping_method"], body.woocommerce-cart input[name^="shipping_method"]',
      function () {
        var val = $(this).val();
        if (val.match('^local_pickup')) {
          $(
            '.woocommerce-shipping-totals .woocommerce-shipping-destination'
          ).hide();
        } else {
          $(
            '.woocommerce-shipping-totals .woocommerce-shipping-destination'
          ).show();
        }
      }
    );
  });
});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
